import { LitElement, html } from "lit-element";
// import WebMidi from "webmidi";
import colorConvert from "color-convert";
import { scale } from "../utils/utils";
import { v4 as uuidv4 } from "uuid";
// import * as Tone from "tone";
const Color = require("color");
class MidiIn extends LitElement {
  static get properties() {
    return {
      source: { type: String },
      channel: { type: String },
      transport: { type: Boolean },
      transportNoteSpeed: { type: String },
      noteFadeSpeed: { type: Number },
      output: { type: String },
      size: { type: Number },
      backgroundColor: { type: String },
      lowNote: { type: Number },
      highNote: { type: Number },
      numNotes: { type: Number },
      noteCount: { type: Number },
      origin: { type: String },
      noteOpacity: { type: Number },
      mode: { type: String },

      ccSource: { type: String },
      startColor: { type: String },
      endColor: { type: String },
      noteColor: { type: String },
      colorSystem: { type: String },
      colorValues: { type: Array },
      orientation: { type: String },
      width: { type: String },
      height: { type: String },
      top: { type: String },
      right: { type: String },
      bottom: { type: String },
      left: { type: String },
      noteWidth: { type: Number },
      noteWidthOrigin: { type: String },

      widthDivision: { type: Number },
      heightDivision: { type: Number },
      offset: { type: Number },
      position: { type: String },
      opacity: { type: Number },
      mixBlendMode: { type: String },
      noteMixBlendMode: { type: String },
      ccResponsive: { type: Boolean },
      knobOneNumber: { type: Number },
      knobTwoNumber: { type: Number },
      knobThreeNumber: { type: Number },
      knobFourNumber: { type: Number },
      knobOneValue: { type: Number },
      knobTwoValue: { type: Number },
      knobThreeValue: { type: Number },
      knobFourValue: { type: Number },
      lightness: { type: Number },
      activeNotes: { type: Array },
      cycleColorValues: { type: Array },
      pitchDetection: { type: Boolean },
      opacityCC: { type: Number },
      ccSource: { type: String },
      boxShadow: { type: String },
      randomColors: { type: Array },
      name: { type: String },
    };
  }

  constructor() {
    super();

    // input
    this.source = null;
    this.channel = null;
    this.output;
    this.ccSource = null;
    this.lowNote = 21;
    this.highNote = 108;

    this.noteCount = 0;
    this.numNotes;

    // size
    this.size = 1;

    // color
    this.backgroundColor = "rgb(0, 0, 0";
    this.startColor = "blue";
    this.endColor = "red";
    this.noteColor = null;
    this.opacity = 1;
    this.noteOpacity = 1;
    this.boxShadow = "0";
    this.mixBlendMode = "normal";
    this.noteMixBlendMode = "normal";

    // responsive color
    this.colorValues = [0, -1, 0, 0];
    this.colorSystem = "cmyk";

    // position
    this.position = "absolute";
    this.orientation = "vertical";
    this.origin = "left";
    this.width = "100%";
    this.height = "100%";
    this.widthDivision = 1;
    this.heightDivision = 1;
    this.left = "0";
    this.top = "0";
    this.bottom = "0";
    this.right = "0";
    this.offset = 0;

    // note attributes
    // this.activeNotes = [];
    this.container = null;

    // midi sources
    this.midiSource;
    this.midiOutput;
    this.ccMidiSource;

    this.containerWidth;
    this.containerHeight;

    // web midi
    // WebMidi.enable((error) => {
    //   if (error) {
    //     console.log(error);
    //   } else {
    //     this.midiSource = WebMidi.getInputByName(this.source);
    //     this.midiOutput = WebMidi.getOutputByName(this.output);
    //     this.ccMidiSource = WebMidi.getInputByName(this.ccSource);

    //     if (this.midiSource) {
    //       this.midiSource.addListener(
    //         "noteon",
    //         this.channel,
    //         this.handleNoteOn.bind(this)
    //       );
    //       this.midiSource.addListener(
    //         "noteoff",
    //         this.channel,
    //         this.handleNoteOff.bind(this)
    //       );
    //     }

    //     if (this.ccMidiSource) {
    //       this.ccMidiSource.addListener(
    //         "controlchange",
    //         "all",
    //         this.handleControlChange.bind(this)
    //       );
    //     }
    //   }
    // });
  }

  handleNoteOn(e) {
    if (e.note.number >= this.lowNote && e.note.number <= this.highNote) {
      // this.container = this.shadowRoot.querySelector("#container");
      const element = document.createElement("div");
      element.id = `note${e.note.number}`;

      const { note } = e;
      note.velocity = scale(e.velocity, 0, 1, 0, 127);
      element.style = this.getNoteStyle(note);

      // this.activeNotes.push(element);
      this.container.appendChild(element);

      if (this.numNotes) {
        this.noteCount =
          this.noteCount === this.numNotes - 1 ? 0 : this.noteCount + 1;
      }
    }
  }

  handleNoteOff(e) {
    const elements = this.shadowRoot.querySelectorAll(`#note${e.note.number}`);
    elements.forEach((element) => {
      element.style.opacity = 0;
    });
    setTimeout(() => {
      for (const element of elements) {
        element.remove();
      }
    }, 1000);
  }

  handleToneNote() {}

  handleControlChange(e) {
    this.midiOutput.sendPitchBend(scale(e.value, 0, 127, -1, 1), 1);
    // if (this.opacityCC === e.controller.number) {
    //   this.opacity = scale(e.value, 0, 127, 0, 1);
    // }
  }

  getNoteColorResponsive(note) {
    if (!note) {
      return;
    }

    let system = this.colorSystem;
    let rgb = "";
    let responsiveColor;

    responsiveColor = this.colorValues.map((val) => {
      if (val === -1) {
        if (system === "cmyk") {
          return Math.floor(scale(note.velocity, 0, 127, 0, 100));
        }
        if (system === "lab") {
          return Math.floor(scale(note.velocity, 0, 127, 0, 100));
        }
        if (system === "rgb") {
          return Math.floor(scale(note.velocity, 0, 127, 0, 255));
        }
      } else {
        return val;
      }
    });

    if (system === "rgb") {
      rgb = responsiveColor;
    } else if (system === "cmyk") {
      rgb = colorConvert.cmyk.rgb(responsiveColor);
    } else if (system === "lab") {
      rgb = colorConvert.lab.rgb(responsiveColor);
    }

    return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${1})`;
  }

  getNoteColor(note) {
    if (this.noteColor !== null) {
      return this.noteColor;
    }
    let factor, color, mixedColor;
    switch (this.mode) {
      case "velocity-color":
        factor = scale(note.velocity, 0, 127, 0, 1);
        color = Color.hsl(this.startColor);
        mixedColor = color.mix(Color.hsl(this.endColor), factor);
        break;
      case "sequential-position":
        factor = scale(this.noteCount, 0, this.numNotes, 0, 1);
        color = Color.hsl(this.startColor);
        mixedColor = color.mix(Color.hsl(this.endColor), factor);
        break;
      default:
        factor = scale(note.number, this.lowNote, this.highNote, 0, 1);
        color = Color.hsl(this.startColor);
        mixedColor = color.mix(Color.hsl(this.endColor), factor);
    }

    return mixedColor;
  }

  getNoteWidth() {
    if (this.noteWidth) {
      return this.containerWidth * (this.noteWidth / 100);
    }
    if (this.origin === "top" || this.origin === "bottom") {
      return this.containerWidth;
    }
    return (containerDimension / this.numNotes) * this.size;
  }

  getNoteStyle(note) {
    let style = ``;
    let distanceFromOrigin, width, height;

    const containerDimension =
      this.origin === "top" || this.origin === "bottom"
        ? this.containerHeight
        : this.containerWidth;

    switch (this.mode) {
      case "velocity-position":
        distanceFromOrigin = scale(
          note.velocity,
          0,
          127,
          0,
          containerDimension
        );
        break;
      case "sequential-position":
        distanceFromOrigin = scale(
          this.noteCount,
          0,
          this.numNotes,
          0,
          containerDimension
        );
        width = this.getNoteWidth();
        height =
          this.origin === "top" || this.origin === "bottom"
            ? (containerDimension / this.numNotes) * this.size
            : this.containerHeight;
        break;
      default:
        distanceFromOrigin = scale(
          note.number - this.offset,
          this.lowNote,
          this.highNote,
          0,
          containerDimension
        );

        width =
          this.origin === "top" || this.origin === "bottom"
            ? this.containerWidth
            : (this.containerWidth / (this.highNote - this.lowNote)) *
              this.size;

        height =
          this.origin === "left" || this.origin === "right"
            ? this.containerHeight
            : (this.containerHeight / (this.highNote - this.lowNote)) *
              this.size;
    }

    style = `
      position: absolute;
      ${this.origin}: ${distanceFromOrigin}px;
      width: ${width}px;
      height: ${height}px;
      background: ${this.getNoteColor(note)};
      opacity: ${this.noteOpacity};
      transition: opacity ${this.noteFadeSpeed ? this.noteFadeSpeed : 1}s ease;
      mix-blend-mode: ${this.noteMixBlendMode};
      text-align: center;
      ${this.noteWidthOrigin ? this.noteWidthOrigin : "left"}: ${
      this.noteWidthOrigin === "left" ? this.noteWidth : 100 - this.noteWidth
    }%;
      `;

    return style;
  }

  startTransport() {
    Tone.Transport.scheduleRepeat((time) => {
      Tone.Draw.schedule(() => {
        const number = 60;
        this.handleNoteOn({ velocity: 1, note: { number } });
        setTimeout(() => this.handleNoteOff({ note: { number } }, 100));
      }, time);
    }, this.transportNoteSpeed);
  }

  firstUpdated() {
    this.container = this.shadowRoot.querySelector("#container");
    this.containerHeight = window
      .getComputedStyle(this.container)
      .height.slice(0, -2);

    this.containerWidth = window
      .getComputedStyle(this.container)
      .width.slice(0, -2);

    if (this.transport) this.startTransport();
  }

  updated() {
    // TODO: don't always do this
    this.containerHeight = window
      .getComputedStyle(this.container)
      .height.slice(0, -2);

    this.containerWidth = window
      .getComputedStyle(this.container)
      .width.slice(0, -2);
  }

  render() {
    return html`
      <style>
        #container {
          transition: width 0.5s ease, height 0.5s ease, left 0.5s ease,
            top 0.5s ease;
          margin: 0 auto;
          position: ${this.position};
          display: block;
          width: ${this.width
            ? this.width
            : `calc(100% / ${this.widthDivision})`};

          height: ${this.height
            ? this.height
            : `calc(100% / ${this.heightDivision})`};

          left: ${this.left};
          top: ${this.top};
          background: ${this.backgroundColor};
          opacity: ${this.opacity};
          mix-blend-mode: ${this.mixBlendMode};
          overflow: hidden;
        }
      </style>
      <div id="container"></div>
    `;
  }
}

customElements.define("midi-in", MidiIn);
